var _rect, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 12,
    viewBox: "-36 -24 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of South Korea") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: -36,
    y: -24,
    width: 72,
    height: 48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3099325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-6-25H6M-6-22H6M-6-19H6",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M0,17v10"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#cd2e3a",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.6900675)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M0-23.5v3M0,17v3.5M0,23.5v3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.a98006e0448a59d025962bb2b95d4aa6.svg";
export { ForwardRef as ReactComponent };